import React from "react";
import styled from "styled-components";
import { Slide, ToastContainer as ReactToastifyToastContainer } from "react-toastify";

export function MessageToastContainer(): React.JSX.Element {
  return <StyledReactToastifyToastContainer transition={Slide} />;
}

const StyledReactToastifyToastContainer = styled(ReactToastifyToastContainer).attrs({
  className: "toast-container",
  toastClassName: "toast",
})`
  /* .toast-container */
  bottom: 0;

  & > div:last-child {
    margin-bottom: ${(props) => props.theme.spacing.spacing10.toString()};
  }

  .toast {
    /* override some default react-toastify styling values */
    border-radius: 0;
    padding: 0;
    min-height: initial;
    box-shadow: none;
    background: none;
    width: 480px;
    margin: 0;
  }

  button[aria-label="close"] {
    display: none;
  }
`;
